import React, { useState } from 'react';

export function ClinicApiKeyCard({
  prefix,
  secret,
  busy,
  onCreateNew,
  onDismissSecret,
}: {
  prefix?: string;
  secret: string | null;
  busy?: boolean;
  onCreateNew: () => void;
  onDismissSecret: () => void;
}): React.ReactElement {
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [copied, setCopied] = useState(false);
  const masked = `${(prefix || 'oa_live').slice(0, 12)}················`;

  const copy = async () => {
    if (!secret) return;
    await navigator.clipboard?.writeText(secret);
    setCopied(true);
    setOpen(false);
    onDismissSecret();
  };

  const download = () => {
    if (!secret) return;
    const blob = new Blob(
      [`OncoAgent clinic key\nKeep this file private.\n\n${secret}\n`],
      { type: 'text/plain' }
    );
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'oncoagent-clinic-key.txt';
    a.click();
    URL.revokeObjectURL(url);
    setOpen(false);
    onDismissSecret();
  };

  return (
    <div className="oa-ws-secret">
      <div>
        <p className="oa-ws-secret-label">Clinic API key</p>
        <p className="oa-ws-hint" style={{ marginTop: 0 }}>
          For EHR or script access. Same idea as an OpenAI key: we show the full value once.
        </p>
      </div>
      <code className="oa-ws-secret-mask">{open && secret ? secret : masked}</code>
      <div className="oa-ws-actions" style={{ marginTop: '0.65rem' }}>
        {secret ? (
          <>
            {!open ? (
              <button
                type="button"
                className="oa-ws-btn oa-ws-btn-secondary"
                onClick={() => setOpen(true)}
              >
                Reveal key
              </button>
            ) : (
              <>
                <button type="button" className="oa-ws-btn oa-ws-btn-primary" onClick={copy}>
                  {copied ? 'Copied' : 'Copy'}
                </button>
                <button type="button" className="oa-ws-btn oa-ws-btn-secondary" onClick={download}>
                  Download file
                </button>
              </>
            )}
          </>
        ) : (
          <>
            {!confirm ? (
              <button
                type="button"
                className="oa-ws-btn oa-ws-btn-ghost"
                disabled={busy}
                onClick={() => setConfirm(true)}
              >
                Create a new key
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className="oa-ws-btn oa-ws-btn-primary"
                  disabled={busy}
                  onClick={() => {
                    setConfirm(false);
                    onCreateNew();
                  }}
                >
                  Replace key
                </button>
                <button
                  type="button"
                  className="oa-ws-btn oa-ws-btn-ghost"
                  onClick={() => setConfirm(false)}
                >
                  Cancel
                </button>
                <p className="oa-ws-hint" style={{ flexBasis: '100%' }}>
                  The current key stops working as soon as the new one is created.
                </p>
              </>
            )}
          </>
        )}
      </div>
      {secret && open ? (
        <p className="oa-ws-hint">Copy or download it now. After that we hide it for good.</p>
      ) : null}
    </div>
  );
}
